/**
 * "HubSpot" pill — shown next to goals/sub-goals that auto-sync from HS.
 * Ported from q2-goals.html line 880-891.
 *
 * Hover tooltip explains why no manual update is expected on these fields.
 */
export default function HsBadge() {
  return (
    <span
      title="Auto-synced from HubSpot — no manual update needed"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        background: '#ff7a5912',
        color: '#e8652a',
        border: '1px solid #ff7a5930',
        borderRadius: 10,
        padding: '1px 7px',
        fontSize: 9,
        fontWeight: 800,
        marginLeft: 6,
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        cursor: 'default',
      }}
    >
      ↻ HubSpot
    </span>
  )
}
